import { Field, useFormikContext } from 'formik';
import React from 'react';

const InputOptionID = ({ attr, option }) => {
    const { setFieldValue } = useFormikContext();  // Access Formik context

    let options = [];

    // Prepare options based on the `option` prop or `attr.option`
    if (option.length > 0) {
        options = option.map(item => ({
            id: item.id,
            name: item.name,
        }));
    } else {
        options = attr.option?.split(',').map(item => ({
            name: item.trim(),
        }));
    }

    // Handle the change event for the select field
    const handleSelectChange = (e) => {
        const selectedValue = e.target.value;

        console.log(selectedValue);
        

        // Update the "id" field (attr.name) with the selected value
        setFieldValue(attr.name, selectedValue);

        // If the selected value is valid, update the "name" field (attr.name.replace("id", "name"))
        if (selectedValue) {
            const selectedOption = options.find(option => option.id === selectedValue);
            const nameValue = selectedOption ? selectedOption.name : '';

            setFieldValue(attr.name.replace("id", "name"), nameValue); // Update dependent field
        } else {
            // If no option is selected, clear the dependent "name" field
            setFieldValue(attr.name.replace("id", "name"), '');
        }
    };

    return (
        <div className='flex-1 my-3 px-2'>
            <label htmlFor={attr.name}>{attr.placeholder}</label>

            {/* Formik select field */}
            <Field as="select" name={attr.name} className={attr.className} onChange={handleSelectChange}>
                <option value="">{attr.placeholder}</option>
                {options?.map((option, index) => (
                    <option key={index} value={option?.id}>
                        {option?.name}
                    </option>
                ))}
            </Field>

            {/* The dependent name field */}
            <Field name={attr.name.replace("id", "name")} style={{ display: 'none' }}/>
        </div>
    );
};

export default InputOptionID;
